import { render, staticRenderFns } from "./questionBankMangement.vue?vue&type=template&id=7cc6df4a&scoped=true"
import script from "./questionBankMangement.vue?vue&type=script&lang=js"
export * from "./questionBankMangement.vue?vue&type=script&lang=js"
import style0 from "./questionBankMangement.vue?vue&type=style&index=0&id=7cc6df4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6df4a",
  null
  
)

export default component.exports